export default "__VITE_ASSET__DWtvjVtJ__"